import { ItiHttpService } from "@/iti-core-react/services/iti-http-service";
import { API } from "../api";
import { MenuListDto } from "../dtos/menu-list-dto";
import { TabsDto } from "../dtos/tabs-dto";

export const MenuOptionsService = {
	async getMainMenu(): Promise<MenuListDto[]> {
		const res = await ItiHttpService.get(
			API.centralizedAuth.usersCurrent.menuOptions.main,
		);
		return res.map((item: MenuListDto) => new MenuListDto(item));
	},
	async getUserMenu(): Promise<MenuListDto[]> {
		const res = await ItiHttpService.get(
			API.centralizedAuth.usersCurrent.menuOptions.user,
		);
		return res.map((item: MenuListDto) => new MenuListDto(item));
	},
	async getUserTabs(): Promise<TabsDto[]> {
		const res = await ItiHttpService.get(
			API.centralizedAuth.usersCurrent.menuOptions.tab,
		);
		return res.map((item: TabsDto) => new TabsDto(item));
	},
};
